import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  TextField
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const RestPeriodRules = ({ baseline, handleChange }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">Rest Period Rules</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Min Rest Hours (Standard)"
              type="number"
              value={baseline.minRestHoursStandard}
              onChange={(e) => handleChange('minRestHoursStandard', parseFloat(e.target.value))}
              inputProps={{ min: 8, max: 24, step: 0.5 }}
              helperText="Standard minimum rest period (CAR Section 7, Series J)"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Min Rest Hours (1-3 Time Zones)"
              type="number"
              value={baseline.minRestHoursTimeZone1to3}
              onChange={(e) => handleChange('minRestHoursTimeZone1to3', parseFloat(e.target.value))}
              inputProps={{ min: 8, max: 24, step: 0.5 }}
              helperText="Rest for 1-3 time zones crossed"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Min Rest Hours (4-7 Time Zones)"
              type="number"
              value={baseline.minRestHoursTimeZone4to7}
              onChange={(e) => handleChange('minRestHoursTimeZone4to7', parseFloat(e.target.value))}
              inputProps={{ min: 12, max: 48, step: 0.5 }}
              helperText="Rest for 4-7 time zones crossed"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Min Rest Hours (More Than 7 Time Zones)"
              type="number"
              value={baseline.minRestHoursTimeZoneMoreThan7}
              onChange={(e) => handleChange('minRestHoursTimeZoneMoreThan7', parseFloat(e.target.value))}
              inputProps={{ min: 24, max: 72, step: 0.5 }}
              helperText="Rest for more than 7 time zones crossed"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Night Duty Extra Rest Hours"
              type="number"
              value={baseline.nightDutyExtraRestHours}
              onChange={(e) => handleChange('nightDutyExtraRestHours', parseFloat(e.target.value))}
              inputProps={{ min: 0, max: 12, step: 0.5 }}
              helperText="Additional rest for night duty"
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="Night Duty Window Start"
              type="time"
              value={baseline.nightDutyWindowStart}
              onChange={(e) => handleChange('nightDutyWindowStart', e.target.value)}
              InputLabelProps={{ shrink: true }}
              helperText="HH:mm format"
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="Night Duty Window End"
              type="time"
              value={baseline.nightDutyWindowEnd}
              onChange={(e) => handleChange('nightDutyWindowEnd', e.target.value)}
              InputLabelProps={{ shrink: true }}
              helperText="HH:mm format"
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default RestPeriodRules;
